import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'insert-edit-checkbox',
  templateUrl: './checkbox.component.html',
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective }
  ]
})
export class CheckboxComponent {
  @Input() fieldName!: string;
  @Input() label!: string;

  constructor(private formGroupDirective: FormGroupDirective) {}

  getFormControlField() {
    return this.formGroupDirective.form.get(this.fieldName);
  }

}
